import React from "react";
import { connect } from "react-redux";
import * as deviceActions from "src/modules/device/duck/actions";
import {
  getXmppLogin,
  getDeviceName,
  getFamilyName
} from "src/modules/auth/duck/selectors";
import debug from "src/modules/debug-logger";
import { getPresence } from "src/duck/selectors";
import presence from "src/constants/presence";
import { getEnvironmentVariable, electronOnly } from "src/utils/environment";
import parseDevice from "./parseDevice";
import { getCode } from "../duck/selectors";
import DeviceDiscovery from "../lib/DeviceDiscovery";

const remote = window.require("@electron/remote");

const { Provider, Consumer } = React.createContext();

class DeviceDiscoveryProvider extends React.Component {
  constructor(props) {
    super(props);
    const { xmppLogin, deviceName, code } = this.props;
    this.state = {
      deviceDiscovery: new DeviceDiscovery({
        xmppLogin,
        name: deviceName,
        code
      })
    };
  }
  componentDidMount = () => {
    electronOnly(() => {
      remote.app.on("before-quit", this.destroy);
      remote.getCurrentWindow().on("close", this.destroy);
      remote.getCurrentWebContents().on("will-navigate", this.destroy);
      remote.powerMonitor.on("suspend", this.stopBroadcasting);
      remote.powerMonitor.on("lock-screen", this.stopBroadcasting);
      remote.powerMonitor.on("resume", this.startBroadcasting);
      remote.powerMonitor.on("unlock-screen", this.startBroadcasting);
    });

    this.startBroadcasting();
    this.startBrowsing();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.familyName !== this.props.familyName) {
      this.state.deviceDiscovery.updateTxt({
        familyname: this.props.familyName
      });
    }
    if (prevProps.presence !== this.props.presence) {
      if (
        this.props.presence === presence.SENDER_CONNECTED ||
        this.props.presence === presence.RECEIVER_CONNECTED
      ) {
        this.stopBroadcasting();
      } else {
        this.startBroadcasting();
      }
    }
  }

  componentWillUnmount() {
    electronOnly(() => {
      remote.app.off("before-quit", this.destroy);
      remote.getCurrentWindow().off("close", this.destroy);
      remote.getCurrentWebContents().off("will-navigate", this.destroy);
      remote.app.off("suspend", this.stopBroadcasting);
      remote.app.off("lock-screen", this.stopBroadcasting);
      remote.app.off("resume", this.startBroadcasting);
      remote.app.off("unlock-screen", this.startBroadcasting);
    });
    this.destroy();
  }

  startBroadcasting = () => {
    this.state.deviceDiscovery.startBroadcasting({
      familyname: this.props.familyName
    });
  };

  stopBroadcasting = () => {
    this.state.deviceDiscovery.stopBroadcasting();
  };

  destroy = () => {
    this.state.deviceDiscovery.destroy();
  };

  isValidDevice(device) {
    const { xmppLogin } = this.props;
    return (
      device.type === getEnvironmentVariable("BONJOUR_SUFFIX") &&
      device.txt &&
      device.txt.id &&
      device.txt.id !== xmppLogin
    );
  }

  startBrowsing = async () => {
    const { deviceDiscovery } = this.state;
    const { dispatch } = this.props;

    const browser = await deviceDiscovery.startBrowsing();

    browser.on("up", (device) => {
      if (!this.isValidDevice(device)) {
        return;
      }
      const parsedDevice = parseDevice(device);
      debug.deviceDiscovery("browser.on('up') fired", device);
      dispatch(deviceActions.addNearbyDevice(parsedDevice));
    });

    browser.on("down", (device) => {
      if (!this.isValidDevice(device)) {
        return;
      }
      const parsedDevice = parseDevice(device);
      debug.deviceDiscovery("browser.on('down') fired", device);
      dispatch(deviceActions.removeNearbyDevice(parsedDevice.jid));
    });
  };

  render() {
    return (
      <Provider value={this.state.deviceDiscovery}>
        {this.props.children}
      </Provider>
    );
  }
}

function mapStateToProps(state) {
  return {
    xmppLogin: getXmppLogin(state),
    code: getCode(state),
    deviceName: getDeviceName(state),
    familyName: getFamilyName(state),
    presence: getPresence(state)
  };
}

export default connect(mapStateToProps)(DeviceDiscoveryProvider);

export function withDeviceDiscovery(Component) {
  return (props) => (
    <Consumer>
      {(deviceDiscovery) => (
        <Component {...props} deviceDiscovery={deviceDiscovery} />
      )}
    </Consumer>
  );
}
